import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewReportComp from "./Component/ViewReportComp"

const ViewReport =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <ViewReportComp/>
        </div>
        <Footer />
        </>
    )
}

export default ViewReport